import { mapActions, mapGetters } from 'vuex';

/**
 *
 * @param storeModule
 */
export function OrderState(storeModule) {
  return {
    data() {
      return {
        orderId: null,
        orderStatusId: null,
        isPriceApproved: false,
        payments: [],
        otpFlags: {
          requiresOtp: false,
          otpType: null,
          otpSent: false,
          otpVerified: false,
        },
        sanctions: {
          isSanctioned: false,
          sanctionMessage: null,
          status: null,
        },
      };
    },
    mounted() {
      this.orderId = this.getOrderId;
      this.orderStatusId = this.getOrderStatusId;
      this.isPriceApproved = this.getIsPriceApproved;
      this.payments = this.getPayments;
      this.otpFlags = {
        ...this.otpFlags,
        ...this.getOtpFlags,
      };
      this.sanctions = {
        ...this.sanctions,
        ...this.getSanctions,
      };
    },
    computed: {
      ...mapGetters(storeModule, ['getOrderId', 'getOrderStatusId', 'getIsPriceApproved', 'getPayments', 'getOtpFlags',
        'getSanctions', 'requiresOtp', 'isSanctioned', 'sanctionMessage']),
    },
    methods: {
      ...mapActions(storeModule, ['setOrderId', 'setOrderStatusId', 'setIsPriceApproved', 'setOrderPayments',
        'fetchOrderPayments', 'setOtpFlags', 'setSanctions', 'clearOrderData', 'clear', 'saveOrder']),
      orderClearData() {
        this.orderId = null;
        this.orderStatusId = null;
        this.isPriceApproved = false;
        this.payments = [];
        this.otpFlags = {
          requiresOtp: false,
          otpType: null,
          otpSent: false,
          otpVerified: false,
        };
        this.sanctions = {
          isSanctioned: false,
          sanctionMessage: null,
          status: null,
        };
      },
    },
    watch: {
      orderId(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setOrderId(newValue);
        }
      },
      orderStatusId(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setOrderStatusId(newValue);
        }
      },
      isPriceApproved(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setIsPriceApproved(newValue);
        }
      },
      payments: {
        handler(newValue) {
          this.setOrderPayments(newValue);
        },
        deep: true,
      },
      getOtpFlags: {
        handler(val) {
          this.otpFlags = { ...this.otpFlags, ...val };
        },
        deep: true,
      },
      'otpFlags.requiresOtp'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setOtpFlags(this.otpFlags);
        }
      },
      'otpFlags.otpType'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setOtpFlags(this.otpFlags);
        }
      },
      'otpFlags.otpSent'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setOtpFlags(this.otpFlags);
        }
      },
      'otpFlags.otpVerified'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setOtpFlags(this.otpFlags);
        }
      },
      'sanctions.isSanctioned'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setSanctions(this.sanctions);
        }
      },
      'sanctions.sanctionMessage'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setSanctions(this.sanctions);
        }
      },
      'sanctions.status'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setSanctions(this.sanctions);
        }
      },
    },
  };
}
